import type {
  IAdapterConfig,
  MiddlewareConfigClass
} from '@care-portals/api-interfaces';

const config = {
  vitaboom: {
    label: 'Vitaboom',
    functions: {
      CreateOrder: {
        middlewareHandler: 'vitaboom',
        version: 2,
        label: 'Create Order in Vitaboom',
        pipelines: ['order'],
        passPayload: true,
        params: []
      },
      CancelOrder: {
        middlewareHandler: 'vitaboom',
        version: 2,
        label: 'Cancel Vitaboom Order',
        pipelines: ['order'],
        passPayload: true,
        params: []
      },
      SyncFulfillment: {
        middlewareHandler: 'vitaboom',
        version: 2,
        label: 'Sync Vitaboom Fulfillment / Tracking',
        pipelines: ['order'],
        passPayload: true,
        params: []
      },
      HandleWebhook: {
        middlewareHandler: 'vitaboom',
        version: 2,
        label: 'Handle Webhook',
        pipelines: ['webhook'],
        passPayload: true,
        params: []
      }
    }
  }
} as const;

export const VitaboomConfig: IAdapterConfig = {
  ...config
} as unknown as IAdapterConfig;

export type VitaboomFunctionConfiguration = MiddlewareConfigClass<
  typeof config.vitaboom.functions
>;
